



































































































import { Component, Mixins, Ref } from "vue-property-decorator";
import InfiniteLoading from "vue-infinite-loading";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import { Choice } from "@/types";
import { DispAdminOperationLog } from "@/views/operationlog/types";

@Component({
  components: {
    InfiniteLoading,
  },
})
export default class OperationLog extends Mixins(AxiosMixin, UtilMixin) {
  /** 無限ローディング用 */
  @Ref("infiniteLoading") private readonly infinite?: InfiniteLoading;

  /** ログ表示用のテーブルヘッダ情報 */
  private headers = [
    {
      text: "実行日時",
      value: "timestamp_disp",
      align: "start",
    },
    {
      text: "実行管理者",
      value: "staff_name",
      align: "start",
    },
    {
      text: "画面・機能名",
      value: "function_name",
      align: "start",
    },
    {
      text: "操作名",
      value: "operation_name",
      align: "start",
    },
    {
      text: "状態",
      value: "status_name",
      align: "start",
    },
    {
      text: "内容",
      value: "content",
      align: "start",
    },
    {
      text: "IPアドレス",
      value: "ip",
      align: "start",
    },
    {
      text: "OS",
      value: "os",
      align: "start",
    },
    {
      text: "ブラウザ",
      value: "browser",
      align: "start",
    },
  ];

  /** 管理者オペログ情報 */
  private logs: DispAdminOperationLog[] = [];

  /** 読み込み完了日時 */
  private next_timestamp = null;

  /** 開始日 */
  private start_date = this.dateToStr(new Date(), "yyyy-MM-dd");

  /** 開始時 */
  private start_hh = 0;

  /** 開始分 */
  private start_mm = 0;

  /** 終了日 */
  private end_date = this.dateToStr(new Date(), "yyyy-MM-dd");

  /** 終了時 */
  private end_hh = 23;

  /** 終了分 */
  private end_mm = 59;

  /** 選択肢用管理者情報 */
  private adminUsers: Choice[] = [];

  /** 選択中管理者ID */
  private admin_id = 0;

  /** 選択肢用画面・機能マスタデータ */
  private functions: Choice[] = [];

  /** 選択中画面・機能ID */
  private function_id = 0;

  /** 取得系操作ログを除外するかどうかフラグ */
  private excludeGetLogs = true;

  /** 取得開始日時 */
  private get StartDatetime(): string {
    const hour = ("0" + this.start_hh).slice(-2);
    const minute = ("0" + this.start_mm).slice(-2);

    return `${this.start_date} ${hour}:${minute}`;
  }

  /** 取得終了日時 */
  private get EndDatetime(): string {
    const hour = ("0" + this.end_hh).slice(-2);
    const minute = ("0" + this.end_mm).slice(-2);

    return `${this.end_date} ${hour}:${minute}`;
  }

  created() {
    this.fetchMaster();
  }

  /** マスタデータ取得 */
  private fetchMaster() {
    this.postJsonCheck(
      window.base_url + "/api/opelog/admin/master",
      {},
      (res) => {
        this.adminUsers = res.data.admin_users;
        this.functions = res.data.functions;
      }
    );
  }

  /** データ更新 */
  private fetchData() {
    this.postJsonCheck(
      window.base_url + "/api/opelog/admin/gets",
      {
        start_datetime: this.StartDatetime,
        end_datetime: this.EndDatetime,
        admin_id: this.admin_id,
        function_id: this.function_id,
        timestamp: this.next_timestamp,
        exlclude_get_logs: this.excludeGetLogs,
      },
      (res) => {
        this.logs = this.logs.concat(res.data.operation_logs);
        this.next_timestamp = res.data.next_timestamp;
        this.infinite?.stateChanger.loaded();
        if (!res.data.next_timestamp) {
          this.infinite?.stateChanger.complete();
        }
      }
    );
  }

  /** 検索処理 */
  private search() {
    this.logs = [];
    this.infinite?.stateChanger.reset();
    this.next_timestamp = null;
  }

  private infiniteHandler() {
    this.fetchData();
  }
}
